<template>
<span>
    <span v-if="awaiting_preflight">
        <img width="60" height="60" src="/images/icons/animated-progress-gear-computer-api.gif" />
        Running Preflight Tests
    </span>
    <span v-else>
        <el-button type="primary" style="margin-top:20px" v-on:click="startChain(false)">{{button_label}}</el-button>
    </span>

    <el-dialog
        title="Preflight Issues"
        :visible.sync="should_show_preflight_override_dialog"
    >
        <div :style="'margin-bottom:20px;padding:10px;background-color:'+preflight_bg">{{nice_text}}</div>
        <div>
            <ul>
                <li v-for="error in preflight_response.errors">{{error.text}}</li>
            </ul>
        </div>
        <el-button v-if="preflight_response.status !== 'fatal'" :style="'background-color:'+preflight_bg" @click="startChain(true)">Continue anyway</el-button>
        <el-button @click="should_show_preflight_override_dialog=false">Stop</el-button>

    </el-dialog>
</span>
</template>

<script>
import {overrides} from "vue-tour/.eslintrc";

export default {
    name: "JobChainStartButton",
    props: [
        'button_label',
        'extent_id',
        'date_start','date_end','period',
        'data_source_id',
        'type',
        'upload_file'
    ],
    data() {
        return {
            awaiting_preflight: false,
            should_show_preflight_override_dialog: false,
            preflight_response: {status: '',errors: []},
        }
    },
    computed: {
        preflight_bg: function () {
            return (this.preflight_response.status === 'warning') ? 'yellow' : 'pink'
        },
        nice_text: function() {
            return (this.preflight_response.status === 'warning') ? 'Warning' : 'You must fix these before continuing:'
        }
    },
    methods: {
        startChain(override=false) {
            this.should_show_preflight_override_dialog = false
            let options = {
                extent_id: this.extent_id,
                date_start: this.date_start,
                date_end: this.date_end,
                period: this.period,
                data_source_id: this.data_source_id,
                type: "merge",
                upload_file: this.upload_file,
                override: override,
            }
            console.log('options:')
            console.log(options)
            this.awaiting_preflight = true
            axios.post('/api/jobChains/preflight', options).then(response => {
                this.awaiting_preflight = false
                this.preflight_response = response.data
                console.log('preflight response')
                console.log(this.preflight_response)
                if (override || (this.preflight_response.status==='ready')) {
                    axios.post('/api/jobChains', options).then(response => {
                        // console.log(response)
//                    window.location.href = '/progress/'
                        // need to come back so that we pass the job chain to progress
                        window.location.href = '/progress/' + response.data.job_chain_id
                    }).catch(error => {
                        console.log('oops problem starting import')
                        console.log(error.response)
                    })
                } else if (this.preflight_response.status==='warning') {
                    this.should_show_preflight_override_dialog = true
                } else {
                    this.should_show_preflight_override_dialog = true
                    console.log('not going to continue to crawl')
                    console.log(response.data)
                }
            }).catch(error => {
                this.awaiting_preflight = false
                console.log('oops getting preflight info')
                console.log(error.response)
            })
        }
    },
}
</script>

<style scoped>

</style>